import { DataTypeSearchCombo } from 'modules/domains';
import { SetRequirementFn, useSetRequirement } from './useSetRequirement';
import { useRequirement } from './useRequirement';

export const useRequirementState = (): [
  requirement: DataTypeSearchCombo,
  setRequirement: SetRequirementFn,
] => {
  const requirement = useRequirement();
  const setRequirement = useSetRequirement();
  return [requirement, setRequirement];
};
